import React from "react";
import { Button, useMediaQuery } from "@material-ui/core";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import Styles from "../../../scss/taxes.module.scss";
import DotMenu from "../../../yoello-lib/modules/components/DotMenu";
import { IReduxAppState } from "../../../reducers";
import { useHistory } from "react-router";
import { APPLY_TO_FEES, APPLY_TO_ITEMS, TAXES_URL } from "../../../const/URL.const";
import useCheckPermissions from "../../../hooks/useCheckPermissions";
import { PERMISSIONS } from "../../../const/permissions.const";
import DisabledActionWrapper from "../../../yoello-lib/modules/components/DisabledActionWrapper";

interface ITaxListButtonsProps {
  id: string;
  taxName: string;
  isVenueOpen: boolean;
}

export function TaxListButtons({
  id,
  taxName,
  isVenueOpen,
}: ITaxListButtonsProps) {
  const { t } = useTranslation();
  const isButton = useMediaQuery("(min-width:885px)");
  const isEposNow = useSelector((state: IReduxAppState) => state.isEposNow);
  const history = useHistory();

  const { hasPermission, onFailedInteraction } = useCheckPermissions(PERMISSIONS.MENU_MANAGEMENT);
  
  function onClick(e: any, id: string, name: string, open: string) {

    if (e) {
      e.stopPropagation();
    }
    const taxName = name;
    history.push(`${TAXES_URL}${APPLY_TO_ITEMS}/${id}`, {
      taxName
    })

  }

  function onClickFees(e: any, id: string, name: string, open: string) {
    if (e) {
      e.stopPropagation();
    }
    const taxName = name;
    history.push(`${TAXES_URL}${APPLY_TO_FEES}/${id}`, {
      taxName
    })
  }

  const items = t("taxes.columns.items");
  const fees = t("taxes.columns.fees");

  return (
    <span key={`${id}-taxes-btn`}>
      {(!isButton && isEposNow) || isButton ? (
        <>
          {!isEposNow && (
            <DisabledActionWrapper disabled={!hasPermission} onDisabledClick={onFailedInteraction}>
            <Button
              onClick={(e) => onClick(e, id, taxName, `${isVenueOpen}`)}
              style={{ color: "#737FA4" }}
              disabled={!hasPermission}
            >
              {t("taxes.columns.applyItems")}
            </Button>
            </DisabledActionWrapper>
            
          )}
          <DisabledActionWrapper disabled={!hasPermission} onDisabledClick={onFailedInteraction}>
            <Button
              onClick={(e) => onClickFees(e, id, taxName, `${isVenueOpen}`)}
              style={{ color: "#737FA4" }}
              disabled={!hasPermission}
            >
              {t("taxes.columns.applyFees")}
            </Button>
          </DisabledActionWrapper>
          
        </>
      ) : (
        <div className={Styles.DotMenu}>
          <DotMenu
            isNotPadding={true}
            options={[
              {
                name: items,
                onClick: (e: any) => onClick(e, id, taxName, `${isVenueOpen}`),
              },
              {
                name: fees,
                onClick: (e: any) =>
                  onClickFees(e, id, taxName, `${isVenueOpen}`),
              },
            ]}
          />
        </div>
      )}
    </span>
  );
}
